import { t } from '@/i18n';

export const homeBreadcrumbItem = {
  label: t('components.simple_breadcrumb.home_breadcrumb_item.home_breadcrumb'),

  link: '/',
};
